import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";
import { useDispatch, useSelector } from "react-redux";
import connectionActions from "../../redux/connections/actions";
import PropTypes from "prop-types";
import { DotLoader } from "react-spinners";
import { css } from "@emotion/react";
import { database } from "../../firebase";
import './search.css'
const Search = ({ results = {}, history }) => {
  const dispatch = useDispatch();
  const { search = [] } = useSelector((state) => ({
    user: state.profile.user,
    creditzIds: state.profile.creditzIds,
  }));
  const rolesRef = useRef(null);
  const genreRef = useRef(null);
  const locationRef = useRef(null);

  const [selectedRole, setSelectedRole] = useState();
  const [selectedGenre, setSelectedGenre] = useState();
  const [selectedLocation, setSelectedLocation] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch({
      type: connectionActions.SET_STATE,
      payload: {
        filters: {
          role: selectedRole?.toLowerCase(),
          genre: selectedGenre?.toLowerCase(),
          location: selectedLocation?.toLowerCase(),
        },
      },
    });
  }, [selectedRole, selectedGenre, selectedLocation]);

  const onChangeRole = (role) => {
    setSelectedRole(role);
  };

  const onChangeGenre = (genre) => {
    setSelectedGenre(genre);
  };

  const onChangeLocation = (location) => {
    setSelectedLocation(location);
  };

  const {
    // loading,
    currentUser,
    pending = [],
    allUsers = [],
    filters = {},
    pendingConnections = [],
  } = useSelector((state) => ({
    // loading: state.connection.loading,
    currentUser: state.profile.currentUser,
    allUsers: state.connection.allUsers,
    pending: state.creditz.creditz,
    filters: state.connection.filters,
    pendingConnections: state.connection.pendingConnections,
  }));

  const [list, setList] = useState([]);

  useEffect(() => {
    dispatch({
      type: connectionActions.FIND_ALL,
    });
  }, []);

  const [requests, setRequests] = useState([]);
  function setRequest(uid) {
     database
      .ref(`/connectuser/${uid}`)
      .child(currentUser.uid)
      .set({
        status: "Pending",
      })
      .then(() => {
        database.ref(`/requests/${currentUser.uid}`).child(uid).set({
          status: "Pending",
        });
        database.ref(`/requests/${uid}`).child(currentUser.uid).set({
          status: "Pending",
        });
        getConnectButton();
      });
  }
  const [button, setButton] = useState([]);
  function getConnectButton() {
    return database
      .ref(`/requests/${currentUser.uid}`)
      .once("value")
      .then((snapshot) => {
        const arr = [];
        arr.push(snapshot.val());
        setButton(arr);
      });
  }

  useEffect(() => {
    makeSearch();
    const locationset = new Set();
    allUsers.map((user) => {
      locationset.add(user.location);
    });
    const locations = [];
    for (const item of locationset) locations.push(item);
    dispatch({
      type: connectionActions.SET_STATE,
      payload: { locations },
    });
    getConnectButton();
  }, [allUsers]);

  const makeSearch = () => {
    setLoading(true);
    const l = allUsers.filter((user) => {
      return (
        (user.genre?.toLowerCase()?.includes(filters.genre) &&
          user.location?.toLowerCase().includes(filters.location)) 
        // user.role?.toLowerCase()?.includes(filters.role)
      );
    });
    setLoading(false);
    setList(l);
  };

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: purple;
    color: purple;
    opacity: 0.5;
  `;

  let [color] = useState();
  document.title = "Search User";
  return (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content ">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-3">
              <div className="mb-5">
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                  {loading == true ? (
                    <DotLoader
                      color={color}
                      css={override}
                      size={100}
                      color={"#7444C0"}
                    />
                  ) : (
                    allUsers &&
                    allUsers.map((allUsers, index) => {
                      if (allUsers.uid !== currentUser.uid) {
                        return (
                          <div className="col" key={index}>
                            <div className="rounded-xl shadow-xs p-4 bg-white text-center">
                              <img
                                src={allUsers.profileImageUrl}
                                className="mmwh-100 rounded-circle"
                                alt="user"
                              />
                              <h5
                                className="fw-bold mt-3 text-capitalize"
                                id="purple"
                              >
                                <Link to={`/profile/${allUsers.uid}`}>
                                  {allUsers.firstName} {allUsers.lastName}
                                </Link>
                              </h5>
                              <div className="d-flex flex-wrap justify-content-evenly my-4 text-muted">
                                <div className="px-1">
                                  <h4 className="fw-bold fs-6 mb-0">
                                    {allUsers.accountType}
                                  </h4>
                                  <span className="fs-13">Role</span>
                                </div>
                                <div className="px-1">
                                  <h4 className="fw-bold fs-6 mb-0">
                                    {allUsers.location}
                                  </h4>
                                  <span className="fs-13">Location</span>
                                </div>
                              </div>
                              <div className="connect-btn d-flex flex-column justify-content-center text-center align-items-center">
                                {button &&
                                button.filter(Boolean).length &&
                                Object.keys(button[0]).includes(
                                  allUsers.uid
                                ) ? (
                                  ""
                                ) : (
                                  <button
                                    className="btn btn-secondary rounded-pill fw-semibold px-3"
                                    onClick={() => setRequest(allUsers.uid)}
                                  >
                                    Connect
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Aside */}
      <AsideContacts></AsideContacts>
    </>
  );
};

Search.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Search);
